// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { CalculateFlexAccountAmountPredictionData, CalculateFlexAccountAmountPredictionErrors, CalculateFlexAccountAmountPredictionResponses, GetAllInboxMessagesData, GetAllInboxMessagesErrors, GetAllInboxMessagesResponses, GetAllPowersOfAttorneyData, GetAllPowersOfAttorneyErrors, GetAllPowersOfAttorneyResponses, GetApiV3CustomersByCustomerIdNotificationsData, GetApiV3CustomersByCustomerIdNotificationsErrors, GetApiV3CustomersByCustomerIdNotificationsResponses, GetContractFacilityRelationsData, GetContractFacilityRelationsErrors, GetContractFacilityRelationsResponses, GetCostSummaryForCurrentPeriodData, GetCostSummaryForCurrentPeriodErrors, GetCostSummaryForCurrentPeriodResponses, GetCustomerFacilitiesData, GetCustomerFacilitiesErrors, GetCustomerFacilitiesResponses, GetCustomerMeterInformationWithConnectedContractsData, GetCustomerMeterInformationWithConnectedContractsErrors, GetCustomerMeterInformationWithConnectedContractsResponses, GetCustomerMeterValuesData, GetCustomerMeterValuesErrors, GetCustomerMeterValuesResponses, GetDeviceByIdData, GetDeviceByIdErrors, GetDeviceByIdResponses, GetDevicesData, GetDevicesErrors, GetDevicesResponses, GetForecastCustomerUpcomingContractData, GetForecastCustomerUpcomingContractErrors, GetForecastCustomerUpcomingContractResponses, GetForecastSummaryForCurrentPeriodData, GetForecastSummaryForCurrentPeriodErrors, GetForecastSummaryForCurrentPeriodResponses, GetHeadsUpData, GetHeadsUpErrors, GetHeadsUpResponses, GetHistoricalTemperaturesData, GetHistoricalTemperaturesErrors, GetHistoricalTemperaturesResponses, GetInvoicedAmountSummaryData, GetInvoicedAmountSummaryErrors, GetInvoicedAmountSummaryResponses, GetInvoiceData, GetInvoiceErrors, GetInvoiceHeadsAndFlexAccountStatementsData, GetInvoiceHeadsAndFlexAccountStatementsErrors, GetInvoiceHeadsAndFlexAccountStatementsResponses, GetInvoiceResponses, GetInvoicesData, GetInvoicesErrors, GetInvoicesGroupedByMonthData, GetInvoicesGroupedByMonthErrors, GetInvoicesGroupedByMonthResponses, GetInvoicesResponses, GetPowerOfAttorneyByIdData, GetPowerOfAttorneyByIdErrors, GetPowerOfAttorneyByIdResponses, GetProductTourData, GetProductTourErrors, GetProductTourResponses, GetProductToursData, GetProductToursErrors, GetProductToursResponses, GetSummaryForCurrentPeriodData, GetSummaryForCurrentPeriodErrors, GetSummaryForCurrentPeriodResponses, GetUnreadInboxMessageCountData, GetUnreadInboxMessageCountErrors, GetUnreadInboxMessageCountResponses, InvalidateNotificationsCacheData, InvalidateNotificationsCacheErrors, InvalidateNotificationsCacheResponses, MarkMessageAsReadData, MarkMessageAsReadErrors, MarkMessageAsReadResponses, SaveProductTourStateData, SaveProductTourStateErrors, SaveProductTourStateResponses, SetDeviceTemperatureByIdData, SetDeviceTemperatureByIdErrors, SetDeviceTemperatureByIdResponses, UpdatePoaStateData, UpdatePoaStateErrors, UpdatePoaStateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const getDevices = <ThrowOnError extends boolean = false>(options: Options<GetDevicesData, ThrowOnError>) => (options.client ?? client).get<GetDevicesResponses, GetDevicesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customer/{customerId}/devices',
    ...options
});

export const getDeviceById = <ThrowOnError extends boolean = false>(options: Options<GetDeviceByIdData, ThrowOnError>) => (options.client ?? client).get<GetDeviceByIdResponses, GetDeviceByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customer/{customerId}/devices/{deviceId}',
    ...options
});

export const setDeviceTemperatureById = <ThrowOnError extends boolean = false>(options: Options<SetDeviceTemperatureByIdData, ThrowOnError>) => (options.client ?? client).put<SetDeviceTemperatureByIdResponses, SetDeviceTemperatureByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customer/{customerId}/devices/{deviceId}/temperature',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get facilities for customer
 */
export const getCustomerFacilities = <ThrowOnError extends boolean = false>(options: Options<GetCustomerFacilitiesData, ThrowOnError>) => (options.client ?? client).get<GetCustomerFacilitiesResponses, GetCustomerFacilitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/facilities',
    ...options
});

/**
 * Get facility relationships for given metering points. This is used to determine parent-child relationships between facilities, which can be used to fetch utility usage on child facilities.
 * This is the way to found any related facilities that is part of "special time series".
 */
export const getContractFacilityRelations = <ThrowOnError extends boolean = false>(options: Options<GetContractFacilityRelationsData, ThrowOnError>) => (options.client ?? client).post<GetContractFacilityRelationsResponses, GetContractFacilityRelationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/facilities/relations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Beräknar förväntad månadskostnad för flexkonto (utjänmad betalning) för en kund.
 * Den automatiserade beräkningen baseras på de 12 senaste månadernas fakturor.
 * Notera att värdet på FlexAmountPrediction.AmountPrediction är -1 om ingen beräkning kunde göras. I det fallet finns en beskrivning av anledningen i FlexAmountPrediction.NoAmountPredictionReason.
 */
export const calculateFlexAccountAmountPrediction = <ThrowOnError extends boolean = false>(options: Options<CalculateFlexAccountAmountPredictionData, ThrowOnError>) => (options.client ?? client).get<CalculateFlexAccountAmountPredictionResponses, CalculateFlexAccountAmountPredictionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/flexaccountamountprediction',
    ...options
});

/**
 * Get all inbox messages.
 */
export const getAllInboxMessages = <ThrowOnError extends boolean = false>(options: Options<GetAllInboxMessagesData, ThrowOnError>) => (options.client ?? client).get<GetAllInboxMessagesResponses, GetAllInboxMessagesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/inbox',
    ...options
});

/**
 * Mark a message as read.
 */
export const markMessageAsRead = <ThrowOnError extends boolean = false>(options: Options<MarkMessageAsReadData, ThrowOnError>) => (options.client ?? client).post<MarkMessageAsReadResponses, MarkMessageAsReadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/inbox/{messageId}/read',
    ...options
});

/**
 * Get unread inbox messages count
 */
export const getUnreadInboxMessageCount = <ThrowOnError extends boolean = false>(options: Options<GetUnreadInboxMessageCountData, ThrowOnError>) => (options.client ?? client).get<GetUnreadInboxMessageCountResponses, GetUnreadInboxMessageCountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/inbox/unreadcount',
    ...options
});

/**
 * Get invoices complete with invoice details and flex account statements if any
 */
export const getInvoices = <ThrowOnError extends boolean = false>(options: Options<GetInvoicesData, ThrowOnError>) => (options.client ?? client).get<GetInvoicesResponses, GetInvoicesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/invoices',
    ...options
});

/**
 * Get one specific invoice complete with invoice details and flex account statements if any
 */
export const getInvoice = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceData, ThrowOnError>) => (options.client ?? client).get<GetInvoiceResponses, GetInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/invoices/{invoiceNumber}',
    ...options
});

/**
 * Get invoiced amount summary
 */
export const getInvoicedAmountSummary = <ThrowOnError extends boolean = false>(options: Options<GetInvoicedAmountSummaryData, ThrowOnError>) => (options.client ?? client).get<GetInvoicedAmountSummaryResponses, GetInvoicedAmountSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/invoices/aggregation',
    ...options
});

/**
 * Get invoices grouped by month
 */
export const getInvoicesGroupedByMonth = <ThrowOnError extends boolean = false>(options: Options<GetInvoicesGroupedByMonthData, ThrowOnError>) => (options.client ?? client).get<GetInvoicesGroupedByMonthResponses, GetInvoicesGroupedByMonthErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/invoices/byMonth',
    ...options
});

/**
 * Get invoice heads and flex account statements only, no invoice details
 */
export const getInvoiceHeadsAndFlexAccountStatements = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceHeadsAndFlexAccountStatementsData, ThrowOnError>) => (options.client ?? client).get<GetInvoiceHeadsAndFlexAccountStatementsResponses, GetInvoiceHeadsAndFlexAccountStatementsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/invoices/flexaccountstatements',
    ...options
});

/**
 * Gets metervalues data for customer from MeterValuesAPI
 */
export const getCustomerMeterValues = <ThrowOnError extends boolean = false>(options: Options<GetCustomerMeterValuesData, ThrowOnError>) => (options.client ?? client).get<GetCustomerMeterValuesResponses, GetCustomerMeterValuesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/metervalues',
    ...options
});

/**
 * Gets detailed information for a specific meteringpoint
 */
export const getCustomerMeterInformationWithConnectedContracts = <ThrowOnError extends boolean = false>(options: Options<GetCustomerMeterInformationWithConnectedContractsData, ThrowOnError>) => (options.client ?? client).get<GetCustomerMeterInformationWithConnectedContractsResponses, GetCustomerMeterInformationWithConnectedContractsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/metervalues/meterinformation',
    ...options
});

/**
 * Get all PowerOfAttorney for the logged in user
 */
export const getAllPowersOfAttorney = <ThrowOnError extends boolean = false>(options: Options<GetAllPowersOfAttorneyData, ThrowOnError>) => (options.client ?? client).get<GetAllPowersOfAttorneyResponses, GetAllPowersOfAttorneyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/metervalues/poa',
    ...options
});

/**
 * Update status on an existing power of attorney for the logged in user
 */
export const updatePoaState = <ThrowOnError extends boolean = false>(options: Options<UpdatePoaStateData, ThrowOnError>) => (options.client ?? client).put<UpdatePoaStateResponses, UpdatePoaStateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/metervalues/poa',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a specific Power Of Attorney for the logged in user.
 */
export const getPowerOfAttorneyById = <ThrowOnError extends boolean = false>(options: Options<GetPowerOfAttorneyByIdData, ThrowOnError>) => (options.client ?? client).get<GetPowerOfAttorneyByIdResponses, GetPowerOfAttorneyByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/metervalues/poa/{permissionId}',
    ...options
});

export const getApiV3CustomersByCustomerIdNotifications = <ThrowOnError extends boolean = false>(options: Options<GetApiV3CustomersByCustomerIdNotificationsData, ThrowOnError>) => (options.client ?? client).get<GetApiV3CustomersByCustomerIdNotificationsResponses, GetApiV3CustomersByCustomerIdNotificationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/notifications',
    ...options
});

/**
 * Get historical temperatures for a specific facility and metering point.
 * Either facilityKey or meteringPointId must be provided.
 * All time values are in UTC.
 */
export const getHistoricalTemperatures = <ThrowOnError extends boolean = false>(options: Options<GetHistoricalTemperaturesData, ThrowOnError>) => (options.client ?? client).get<GetHistoricalTemperaturesResponses, GetHistoricalTemperaturesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/customers/{customerId}/weather/historical',
    ...options
});

/**
 * Get a customer id specific heads up about certain upcoming or due events
 * such as invoices due dates, contracts about to expire (less than 65 days), planned maintenance and more.
 */
export const getHeadsUp = <ThrowOnError extends boolean = false>(options: Options<GetHeadsUpData, ThrowOnError>) => (options.client ?? client).get<GetHeadsUpResponses, GetHeadsUpErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/dashboard/{customerId}/headsup',
    ...options
});

/**
 * Gets forecast for customer with upcoming contract.
 */
export const getForecastCustomerUpcomingContract = <ThrowOnError extends boolean = false>(options: Options<GetForecastCustomerUpcomingContractData, ThrowOnError>) => (options.client ?? client).get<GetForecastCustomerUpcomingContractResponses, GetForecastCustomerUpcomingContractErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/dashboard/{customerId}/metervalues/forecast',
    ...options
});

/**
 * Gets a summary of the customer's current consumption on all contracted utility categories.
 */
export const getSummaryForCurrentPeriod = <ThrowOnError extends boolean = false>(options: Options<GetSummaryForCurrentPeriodData, ThrowOnError>) => (options.client ?? client).get<GetSummaryForCurrentPeriodResponses, GetSummaryForCurrentPeriodErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/dashboard/{customerId}/metervalues/summary/current',
    ...options
});

/**
 * Gets a cost summary of the customer's current consumption on all contracted utility categories.
 */
export const getCostSummaryForCurrentPeriod = <ThrowOnError extends boolean = false>(options: Options<GetCostSummaryForCurrentPeriodData, ThrowOnError>) => (options.client ?? client).get<GetCostSummaryForCurrentPeriodResponses, GetCostSummaryForCurrentPeriodErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/dashboard/{customerId}/metervalues/summary/current_cost',
    ...options
});

/**
 * Gets a forecast based on current consumption on all contracted utility categories.
 */
export const getForecastSummaryForCurrentPeriod = <ThrowOnError extends boolean = false>(options: Options<GetForecastSummaryForCurrentPeriodData, ThrowOnError>) => (options.client ?? client).get<GetForecastSummaryForCurrentPeriodResponses, GetForecastSummaryForCurrentPeriodErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/dashboard/{customerId}/metervalues/summary/current_forecast',
    ...options
});

export const invalidateNotificationsCache = <ThrowOnError extends boolean = false>(options?: Options<InvalidateNotificationsCacheData, ThrowOnError>) => (options?.client ?? client).delete<InvalidateNotificationsCacheResponses, InvalidateNotificationsCacheErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/notifications/cache',
    ...options
});

/**
 * Get all completed product tours for the logged in user
 */
export const getProductTours = <ThrowOnError extends boolean = false>(options?: Options<GetProductToursData, ThrowOnError>) => (options?.client ?? client).get<GetProductToursResponses, GetProductToursErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/producttour',
    ...options
});

/**
 * Get a specific product tour if it's been completed by the logged in user
 */
export const getProductTour = <ThrowOnError extends boolean = false>(options: Options<GetProductTourData, ThrowOnError>) => (options.client ?? client).get<GetProductTourResponses, GetProductTourErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/producttour/{id}',
    ...options
});

/**
 * Create or update a product tour for the logged in user
 */
export const saveProductTourState = <ThrowOnError extends boolean = false>(options: Options<SaveProductTourStateData, ThrowOnError>) => (options.client ?? client).put<SaveProductTourStateResponses, SaveProductTourStateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/producttour/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
